// Parking lot grid filtering (segmented control pills). Pure DOM show/hide, no reload.
document.addEventListener('DOMContentLoaded', function () {
    const segments = document.querySelectorAll('.parking-lots__segment');
    const cards = document.querySelectorAll('.lot-card');
    const countEl = document.querySelector('.parking-lots__result-count-num');

    if (!segments.length) {
        return;
    }

    segments.forEach(function (segment) {
        segment.addEventListener('click', function () {
            segments.forEach(function (s) { s.classList.remove('is-active'); });
            segment.classList.add('is-active');

            const filter = segment.getAttribute('data-filter');
            let visible = 0;

            cards.forEach(function (card) {
                const tags = (card.getAttribute('data-filter-tags') || '').split('|');
                const match = tags.indexOf(filter) !== -1;
                card.classList.toggle('is-hidden', !match);
                if (match) {
                    visible++;
                }
            });

            if (countEl) {
                countEl.textContent = visible;
            }
        });
    });
});
